import { OscillatorInstrument } from "../Nodes/OscillatorInstrument.js";
import { NoteEvent } from "../Notation/SongEvents.js";
import { BaseTrack } from "./BaseTrack.js";
import NoteHelper from "../../HelperModules/NoteHelper.js";
export class OscillatorTrack extends BaseTrack {
    constructor(metadata, context, scheduleEvent, connectionManager, settings) {
        let instrument = new OscillatorInstrument(context, settings ? settings.source : undefined);
        super(metadata, context, scheduleEvent, instrument, connectionManager, settings);
        this._pitchStrings = {};
        if (settings) {
            settings.events.forEach(event => {
                if (event.pitchString in this._pitchStrings) {
                    this._pitchStrings[event.pitchString] += 1;
                }
                else {
                    this._pitchStrings[event.pitchString] = 1;
                }
            });
        }
    }
    get highestPitch() {
        let highest = "C0";
        Object.keys(this._pitchStrings).forEach(pitchString => {
            if (NoteHelper.distanceBetweenNotes(pitchString, highest) > 0) {
                highest = pitchString;
            }
        });
        return highest;
    }
    get lowestPitch() {
        let lowest = "B9";
        Object.keys(this._pitchStrings).forEach(pitchString => {
            if (NoteHelper.distanceBetweenNotes(pitchString, lowest) < 0) {
                lowest = pitchString;
            }
        });
        return lowest;
    }
    addNote(startPosition, pitch, duration) {
        let event = new NoteEvent(startPosition, pitch, duration);
        this._timeline.addEvent(event);
        if (pitch in this._pitchStrings) {
            this._pitchStrings[pitch] += 1;
        }
        else {
            this._pitchStrings[pitch] = 1;
        }
        return event;
    }
    removeNote(event) {
        this.timeline.removeEvent(event);
        if (event.pitchString in this._pitchStrings) {
            this._pitchStrings[event.pitchString] -= 1;
            if (this._pitchStrings[event.pitchString] < 1) {
                delete this._pitchStrings[event.pitchString];
            }
        }
    }
    removeNoteByIndex(index) {
        this._timeline.events.removeAt(index);
    }
    songEventHandler(event) {
        if (event instanceof NoteEvent) {
            let eventStart = this._startTime + this._metadata.positionQuarterNoteToSeconds(event.startPosition);
            let eventEnd = this._startTime + this._metadata.positionQuarterNoteToSeconds(event.startPosition + event.duration);
            this.audioSource.playNote(eventStart, eventEnd, event.pitch);
        }
        else {
            throw new Error("OscillatorTrack cannot handle this event type:" + event.constructor.name);
        }
    }
}
//# sourceMappingURL=OscillatorTrack.js.map